import paddyFieldHistory from "@/api/paddy-field-histories";

export default {
  state: {},
  mutations: {},
  actions: {
    async retrievePaddyFieldHistories(context, management_id = null) {
      try {
        let params;
        if (management_id == null) {
          params = {
            management_id: await context.dispatch("showManagementID"),
            account_id: await context.dispatch("showAccountID"),
          }
        }
        else {
          params = {
            management_id: management_id,
            account_id: await context.dispatch("showAccountID"),
          }
        }
        const response = await paddyFieldHistory.index(params);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
